/* eslint-disable import/no-cycle */
import axiosIns, { axiosInsNoEnc, axiosDefault } from '@/libs/axios'
import { requestApi } from '@/libs/secret'

/* eslint-disable no-return-assign */
export default {
  namespaced: true,
  state: {
    creditBalance: '0',
    dataInvoice: {
      items: {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [],
      },
      fields: [
        { key: 'invoice_number', label: 'Invoice Number', sortable: true },
        { key: 'company_name', label: 'Company Name', sortable: true },
        { key: 'invoice_type', label: 'Invoice Type', sortable: true },
        { key: 'invoice_date', label: 'Invoice Date', sortable: true },
        { key: 'due_date', label: 'Due Date', sortable: true },
        { key: 'total', label: 'Total', sortable: true },
        { key: 'status', label: 'Status' },
        { key: 'actions', label: '' },
      ],
      status: [
        {
          1: 'Unpaid', 2: 'Waiting Approval', 3: 'Paid', 4: 'Rejected', 5: 'Cancelled',
        },
        {
          1: 'warning', 2: 'warning', 3: 'success', 4: 'danger', 5: 'danger',
        },
      ],
      sortBy: '',
      sortDesc: false,
      search: '',
      startdate: '',
      enddate: '',
    },
    detailInvoice: {},
    totalBalance: {},
  },
  getters: {
    getInvoiceItem: state => state.dataInvoice.items,
    getInvoiceField: state => state.dataInvoice.fields,
    getInvoiceStatus: state => state.dataInvoice.status,
    getCurrentPage: state => state.dataInvoice.items.current_page,
    getSortBy: state => state.dataInvoice.sortBy,
    getSortDesc: state => state.dataInvoice.sortDesc,
    getSearch: state => state.dataInvoice.search,
    getStartDate: state => state.dataInvoice.startdate,
    getEndDate: state => state.dataInvoice.enddate,
    getInvoice: state => state.detailInvoice,
    getCreditBalance: state => state.creditBalance,
    getTotalBalance: state => state.totalBalance,
  },
  mutations: {
    SET_ITEM_DATA: (state, value) => (value ? (state.dataInvoice.items = value) : (state.dataInvoice.items = [])),
    SET_INVOICE_CURRENT_PAGE: (state, value) => (value ? (state.dataInvoice.items.current_page = value) : (state.dataInvoice.items.current_page = 1)),
    SET_INVOICE_SORT_BY: (state, value) => (value ? (state.dataInvoice.sortBy = value) : (state.dataInvoice.sortBy = '')),
    SET_INVOICE_SORT_DESC: (state, value) => (value ? (state.dataInvoice.sortDesc = value) : (state.dataInvoice.sortDesc = false)),
    SET_INVOICE_SEARCH: (state, value) => (value ? (state.dataInvoice.search = value) : (state.dataInvoice.search = '')),
    SET_STARTDATE: (state, value) => (value ? (state.dataInvoice.startdate = value) : (state.dataInvoice.startdate = '')),
    SET_ENDDATE: (state, value) => (value ? (state.dataInvoice.enddate = value) : (state.dataInvoice.enddate = '')),
    SET_DETAIL_INVOICE: (state, value) => (value ? (state.detailInvoice = value) : (state.detailInvoice = {})),
    SET_CREDIT_BALANCE: (state, value) => (value ? (state.creditBalance = value) : (state.creditBalance = '0.00')),
    SET_TOTAL_BALANCE: (state, value) => (value ? (state.totalBalance = value) : (state.totalBalance = {})),
  },
  actions: {
    clearTable({ commit }) {
      commit('SET_INVOICE_CURRENT_PAGE')
      commit('SET_INVOICE_SORT_BY')
      commit('SET_INVOICE_SORT_DESC')
      commit('SET_INVOICE_SEARCH')
    },
    // eslint-disable-next-line no-unused-vars
    getDataList({ commit, rootState, getters }, payload) {
      const desc = (getters.getSortDesc) ? 'desc' : 'asc'
      const type = typeof payload !== 'undefined' ? payload.type : ''
      const format = typeof payload !== 'undefined' ? payload.format : ''
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`page=${getters.getCurrentPage}&start_period=${getters.getStartDate}&end_period=${getters.getEndDate}&sortby=${getters.getSortBy}&sortdir=${desc}&filter=${getters.getSearch}&type=${type}&downloadFormat=${format}`)
        axiosIns.get(`invoice?req=${queryParam.req}`, { headers }).then(response => {
          if (response) {
            commit('SET_ITEM_DATA', response.data)
            resolve(response.data)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    getDataListDownload({ rootState, getters }, payload) {
      const desc = (getters.getSortDesc) ? 'desc' : 'asc'
      const type = typeof payload !== 'undefined' ? payload.type : ''
      const format = typeof payload !== 'undefined' ? payload.format : ''
      // let headers = {
      //   headers: {
      //     Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      //   },
      //   // responseType: 'blob',
      // }
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`page=${getters.getCurrentPage}&start_period=${getters.getStartDate}&end_period=${getters.getEndDate}&sortby=${getters.getSortBy}&sortdir=${desc}&filter=${getters.getSearch}&type=${type}&downloadFormat=${format}`)
        axiosIns.get(`invoice?req=${queryParam.req}`, { headers }).then(response => {
          if (response) {
            resolve(response.data)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    detailInvoice({ commit, rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get(`invoice/${payload}`, { headers }).then(response => {
          if (response) {
            commit('SET_DETAIL_INVOICE', response.data.data)
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    setCreditBalance({ commit, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get('account/creditBalance', { headers }).then(response => {
          if (response) {
            commit('SET_CREDIT_BALANCE', response.data.data.saldo)
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    downloadInvoice({ rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get(`invoice/${payload}/download`, { headers }).then(response => {
          if (response) {
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    confirmPayment({ rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      let formData = new FormData()
      formData.append('invoice_no', payload.invoice_no)
      return new Promise((resolve, reject) => {
        axiosInsNoEnc.post('topup/approval', formData, { headers }).then(response => {
          // commit('SET_DATA_WAITING_APPROVAL', false)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    rejectPayment({ rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      // let formData = new FormData()
      // formData.append('invoice_no', payload.invoice_no)
      // formData.append('reason', payload.reason)
      return new Promise((resolve, reject) => {
        axiosIns.post('topup/rejection', payload, { headers }).then(response => {
          // commit('SET_DATA_WAITING_APPROVAL', false)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    dataTotalBalance({ commit, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get('report/finance', { headers }).then(response => {
          if (response) {
            commit('SET_TOTAL_BALANCE', response.data.data)
            resolve(response.data.data)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    downloadTable({ getters }, payload) {
      const desc = (getters.getManageSortDesc) ? 'desc' : 'asc'
      // const user = rootState.auth.userData.data.id
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`start_period=${getters.getStartDate}&end_period=${getters.getEndDate}&sortby=${getters.getSortBy}&sortdir=${desc}&filter=${getters.getSearch}&type=${payload}`)
        axiosDefault.get(`/invoice-download?req=${queryParam.req}`, { responseType: 'arraybuffer' })
          .then(response => {
            // const newData = response.data
            // let blob = new Blob([response.data], { type: 'application/pdf' }),
            // url = window.URL.createObjectURL(blob)
            // window.open(url)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
  },
}
